import {PrintWindow} from "@/addons/PrintWindow";
import {Conciliacion} from "@/addons/Conciliacion";
import {Factura} from "@/addons/Factura";

export class PrintConsumo extends PrintWindow {
    public async imprimir(factura: any, cliente: any, duplicacion = false): Promise<void> {
        if (factura.tarifa === undefined) {
            const res = await Conciliacion.imprimir(factura, cliente);
            this.finalizarImpresion(res);
        } else {
            const res = await Factura.imprimir(factura, cliente, duplicacion);
            this.finalizarImpresion(res);
        }
    }
}